export default __webpack_public_path__ + "static/media/health_check_table_En.29129b90.webp";